//
export default {

  Social: {
    Facebook: 0,
    Twitter: 1,
    GooglePlus: 2,
    Linkedin: 3,
    Youtube: 4,
    Pinterest: 5,
    Instagram: 6,
    Snapchat: 7,
    Telegram: 8

  }
};